import MediaApi from "@/api/MediaApi";

function upload(formData, idCandidacy, type) {
    formData.append('candidacy', idCandidacy);
    formData.append('type', type);
    return MediaApi.upload(formData)
        .then(response => {
            return {
                originalName: response.data.niceFileName,
                id: idCandidacy,
                mediaId: response.data.id
            };
        })
}

export {upload}
